import type { IconData } from '@stacksjs/iconify-core'

export const sdCard: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M24.008 45c-5.68 0-9.818-.116-12.633-.242c-2.809-.125-4.974-2.295-5.093-5.104c-.135-3.206-.266-8.224-.266-15.649c0-1.866-.013-2.924-.016-3.98c-.004-1.556.467-3.082 1.401-4.326c4.109-5.473 8.812-9.41 11.358-11.342c1.204-.914 2.678-1.363 4.189-1.356a100 100 0 0 1 1.095.01c5.601 0 9.7.114 12.508.238c2.85.125 5.05 2.353 5.17 5.203c.14 3.313.279 8.404.279 15.553s-.14 12.24-.279 15.554c-.12 2.85-2.32 5.078-5.17 5.203c-2.813.124-6.924.238-12.543.238M35 9v5m-6-5v5m-6-5v5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sdCard
